import { RichTextField, RichTextFieldProps } from "@/components/RichTextField";

import useDotPhraseSuggestionExtension from "../../hooks/useDotPhraseSuggestionExtension";
import DotPhraseFieldHint from "../DotPhraseFieldHint";

/**
 * A `RichTextField` that lets a provider type a dotphrase trigger and pick a phrase from an
 * autocomplete. Mounting it is what switches dotphrases on, so a plain `RichTextField` reads no
 * phrase set and subscribes to no store.
 */
export default function DotPhraseRichTextField({
  disabled,
  additionalExtensions = [],
  ...props
}: Omit<RichTextFieldProps, "footer">) {
  const dotPhraseExtensions = useDotPhraseSuggestionExtension(disabled);

  return (
    <RichTextField
      {...props}
      disabled={disabled}
      footer={(editor) => <DotPhraseFieldHint editor={editor} />}
      additionalExtensions={[...dotPhraseExtensions, ...additionalExtensions]}
    />
  );
}
